import { CommonModule } from '@angular/common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule, TooltipModule } from 'ngx-bootstrap';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { YahooPublicKeyWarnModalComponent } from './yahoo-publickey-warn-modal.component';

@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    TooltipModule,
  ],
  exports: [
    YahooPublicKeyWarnModalComponent,
  ],
  declarations: [
    YahooPublicKeyWarnModalComponent,
  ],
  entryComponents: [
    YahooPublicKeyWarnModalComponent,
  ],
})
export class YahooPublikKeyWarnModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: YahooPublikKeyWarnModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-publickey-warn-modal/yahoo-publickey-warn-modal.module.ts